var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "countdown" }, [
    _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.days))]),
    _vm._v("天 "),
    _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.hours))]),
    _vm._v("小时 "),
    _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.minutes))]),
    _vm._v("分钟 "),
    _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.seconds))]),
    _vm._v("秒 "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }